/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Card, CardContent, CardExtra } from '../../../Shared/Card'
import { CardTitle } from '../../../Shared/CardTitle'
import { Link } from 'react-router-dom-v5-compat'
import { Icon, Image } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import { getPublishedProductsSummary } from '../../../../../services/Provider/Provider.service'
import { TIME } from '../../../../../services/date.service'
import useUser from '../../../../Shared/UserProvider/useUser'
import { LoadingPlaceholderCardContent } from '../../../Shared/LoadingPlaceholderCardContent'
import { useDeviceMediaQuery } from '../../../../Shared/UseDeviceMediaQuery/useDeviceMediaQuery'


const PublishedProductsCard = () => {
    const [t] = useTranslation()
    const {user} = useUser()
    const { isMobile } = useDeviceMediaQuery()

    const {data, isLoading} = useQuery({
        queryKey: ['published-products-summary', user.provider.id],
        queryFn: () => getPublishedProductsSummary(user.provider.id),
        staleTime: TIME.HOUR_IN_MS
    })

    return (
      <Card
        css={css`
            border-top: 2px solid ${isLoading ? 'unset' : 'grey'};
            .card-content {
                width: ${isMobile ? '340px' : '360px'};
                height: 164px;
            }
        `}
      >
          {isLoading ? (
            <LoadingPlaceholderCardContent />
          ) : (
            <CardContent>
                <CardTitle
                  css={css`
                    margin-top: .25rem;
                `}
                  title={t('dashboard.published_products.title')}
                />

                <div
                  css={css`
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 90%;
                `}
                >
                    <div
                      css={css`
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(150px, max-content));
                        gap: 1rem;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                    `}
                    >
                        {data.platforms.map((platform) => (
                            <div key={platform.module}
                                 css={css`
                                   display: flex;
                                   justify-content: flex-start;
                                   align-items: center;
                                   gap: .5rem;
                               `}
                            >
                                <Image
                                  src={`/img/platforms/${platform.module}.jpg`}
                                  size={data.platforms.length > 2 ?
                                    'mini' :
                                    'tiny'
                                  }
                                />

                                <strong>{platform.itemsCount}</strong>
                            </div>
                          ),
                        )}
                    </div>
                </div>
            </CardContent>
          )}

          <CardExtra>
              <Link
                to={{
                    pathname: '/categories/publications',
                }}>
                  {t('category_set.manage_link')}
                  <Icon name="arrow right"/>
              </Link>
          </CardExtra>
      </Card>
    )
}

export { PublishedProductsCard }
